
import { isObject } from 'vessel/utils'

export default {
  name: 'VsAside',
  props: {
    position: {
      type: String,
      default: 'left'
    },
    sticky: {
      type: [Boolean, String, Number, Object],
      default: null
    },
    border: {
      type: [Boolean, String, Object],
      default: null
    },
    tag: {
      type: String,
      default: 'aside'
    }
  },
  vessel: {
    default: {
      $attrs: 'all',
      width: '3xl',
      $border: {
        borderColor(value) {
          return value
        },
        borderLeftWidth(value) {
          return value && this.position == 'right' ? true : null
        },
        borderRightWidth(value) {
          return value && this.position == 'left' ? true : null
        }
      }
    },
    child: {
      $stickyValue: {
        height(value) {
          return value ? 'auto' : 'full'
        }
      }
    }
  },
  computed: {
    stickyValue() {
      return isObject(this.sticky) ? this.sticky.top : this.sticky
    },
    smartSticky() {
      return isObject(this.sticky) && this.sticky.smart ? 'smart' : null
    }
  }
}
